import type { ComponentType } from 'react'
import { resolveThemedExportSync } from '@/shared/theme/resolveThemedExportSync'
import {
  FavoriteHeartButtonView,
  type FavoriteHeartButtonProps,
} from './FavoriteHeartButtonView'

const ResolvedFavoriteHeartButton: ComponentType<FavoriteHeartButtonProps> = resolveThemedExportSync(
  'shared/components/FavoriteHeartButton.tsx',
  'FavoriteHeartButton',
  FavoriteHeartButtonView,
)

export function FavoriteHeartButton(props: FavoriteHeartButtonProps) {
  return <ResolvedFavoriteHeartButton {...props} />
}

export type { FavoriteHeartButtonProps }
